import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { IoIosArrowBack } from "react-icons/io";
import SelectedMatchesCard from "./selectedMatchesCard";
// import HumburgerMenu from "../../../assets/icons/humburger.svg";
import bettingService from "../../../api/services/bettingService";
import { Link } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { playSong } from '../../common/actions/common.actions';
import { setSelectedMatchesDetail } from '../../common/components/sidebar/sidebar.actions';
import { GiHamburgerMenu } from "react-icons/gi";
import { TiArrowMaximise } from "react-icons/ti";

const SelectedMatches = ({ setIsLoading }) => {
    const [showOptions, setShowOptions] = useState(false);
    const [selectedMatches, setSelectedMatches] = useState([]);
    // const [selectedMatchesWithDetail, setSelectedMatchesWithDetail] = useState([]);
    const [filter, setFilter] = useState("အားလုံး");
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [expand, setExpand] = useState([]);

    const showHideDetails = (id) => {
        if(expand.includes(id))
            setExpand(expand.filter(el=> el !== id));
        else {
            setExpand([...expand, id]);
        }
    };

    const handleSongClick = async () => {
        dispatch(playSong());
    };

    const handleBackClick = () => {
        handleSongClick();
        navigate('/dashboard');
    };

    const handleHamburgerClick = () => {
        handleSongClick();
        setShowOptions(!showOptions); // Toggle options visibility
    };

    const handleOptionClick = (option) => {
        setFilter(option);
        setShowOptions(false);
    }

    useEffect(() => {
        const fetchData = () => {
            setIsLoading(true);
            bettingService
                .bettingMatchesHistory()
                .then((response) => response.json())
                .then((data) => {
                    // Filter the data based on the selected filter
                    if (data) {
                        // console.log(data);
                        if (filter === "အားလုံး") {
                            setSelectedMatches(data);
                        } else if (filter === "ဘော်ဒီ") {
                            const filteredMatches = data.filter(
                                (match) => match.gamblingTypeId === 1
                            );
                            setSelectedMatches(filteredMatches);
                        } else if (filter === "မောင်း") {
                            const filteredMatches = data.filter(
                                (match) => match.gamblingTypeId === 2
                            );
                            setSelectedMatches(filteredMatches);
                        }
                    }
                    setIsLoading(false);
                })
                .catch((err) => {
                    setIsLoading(false);
                    console.error("API request error:", err);
                });
        };
        fetchData();
    }, [filter, navigate, setIsLoading]);

    const sortedMatches = [...selectedMatches].sort((a, b) => {
        const dateA = new Date(a.createdDate);
        const dateB = new Date(b.createdDate);
        return dateB - dateA;
    });
    // useEffect(() => {
    //   if (selectedMatches && selectedMatches.length > 0) {
    //     const fetchData = async () => {
    //       const detailData = await Promise.all(
    //         selectedMatches.map(async (match) => {
    //           try {
    //             const response = await bettingService.bettingHistoryDetails({
    //               gamblingId: Number(match.gamblingId),
    //               status: "Inplay",
    //             });
    //             const data = await response.json();
    //             if (data && data.length > 0) {
    //               return { ...match, ...data[0] };
    //             }
    //           } catch (err) {
    //             if (err?.response?.status === 401) {
    //               // Redirect to the login page
    //               navigate("/login");
    //             } else {
    //               console.error("API request error:", err);
    //             }
    //           }
    //         })
    //       );
    //       setSelectedMatchesWithDetail(detailData);
    //       setIsLoading(false);
    //     };

    //     fetchData();
    //   }
    // }, [selectedMatches, navigate, setIsLoading]);


    return (
        <div className="flex flex-col w-full h-screen bg-gradient-to-br from-[#EAEAEA] via-green-50 to-[#228B22]/10 relative">

            {/* Header */}
            <div className="relative z-50 bg-gradient-to-r from-[#228B22] via-emerald-600 to-[#1F5F1F] py-4 px-4 shadow-sm">
                <div className="flex justify-between items-center">
                    <div
                        className="flex justify-center items-center"
                        onClick={handleBackClick}
                    >
                        <button
                            className="w-10 h-10 mr-4 flex justify-center items-center text-white rounded-xl active:bg-white/20"
                        >
                            <IoIosArrowBack size={25} />
                        </button>
                        <div>
                            <h3 className="text-white font-bold text-xl">
                                {t("selectedMatches")}
                            </h3>
                            <p className="text-emerald-100 text-xs font-medium">Match History</p>
                        </div>
                    </div>
                    <div className="relative">
                        <div className="flex items-center">
                            <div
                                onClick={handleHamburgerClick}
                                className="w-10 h-10 flex items-center justify-center text-white rounded-xl active:bg-white/20 cursor-pointer"
                            >
                                <GiHamburgerMenu size={22} />
                            </div>
                        </div>
                        {showOptions && (
                            <div className="absolute top-12 rounded-2xl border right-0 bg-white p-4 shadow-lg border-[#228B22]/20 font-myanmarSansPro min-w-[150px] z-50">
                                <div
                                    className={`border-b border-[#228B22]/20 pb-3 pl-2 pr-4 cursor-pointer active:bg-[#228B22]/5 rounded-lg ${filter === "အားလုံး" ? "font-bold bg-gradient-to-r from-[#228B22] to-emerald-600 bg-clip-text text-transparent" : "text-gray-700"
                                        }`}
                                >
                                    <p
                                        onClick={() => handleOptionClick("အားလုံး")}
                                        className="flex items-center"
                                    >
                                        <span className="w-2 h-2 bg-[#228B22] rounded-full mr-3"></span>
                                        {t("all")}
                                    </p>
                                </div>
                                <div
                                    className={`border-b border-[#228B22]/20 py-3 pl-2 pr-4 cursor-pointer active:bg-[#228B22]/5 rounded-lg ${filter === "မောင်း" ? "font-bold bg-gradient-to-r from-[#228B22] to-emerald-600 bg-clip-text text-transparent" : "text-gray-700"
                                        }`}
                                >
                                    <p
                                        onClick={() => handleOptionClick("မောင်း")}
                                        className="flex items-center"
                                    >
                                        <span className="w-2 h-2 bg-[#FFD700] rounded-full mr-3"></span>
                                        {t("maungg")}
                                    </p>
                                </div>
                                <div
                                    className={`pt-3 pl-2 pr-4 cursor-pointer active:bg-[#228B22]/5 rounded-lg ${filter === "ဘော်ဒီ" ? "font-bold bg-gradient-to-r from-[#228B22] to-emerald-600 bg-clip-text text-transparent" : "text-gray-700"
                                        }`}
                                >
                                    <p
                                        onClick={() => handleOptionClick("ဘော်ဒီ")}
                                        className="flex items-center"
                                    >
                                        <span className="w-2 h-2 bg-[#1E90FF] rounded-full mr-3"></span>
                                        {t("body")}
                                    </p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Content */}
            <div className="relative z-10 flex-1 overflow-auto bg-white/50 p-4">
                <div className="space-y-4">
                    {sortedMatches?.map((data, index) => {
                        return (
                            <Link
                                key={`${index}`}
                                to={`/selected-matches-detail/${data?.gamblingId}`}
                                onClick={() => {
                                    dispatch(setSelectedMatchesDetail(data));
                                    handleSongClick();
                                }}
                            >
                                <SelectedMatchesCard match={data} expand={expand} showHideDetails={showHideDetails} />
                            </Link>
                        );
                    })}
                </div>
            </div>
        </div >
    );
}

export default SelectedMatches;
